function makeId() {
  return `el_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
}

export const PRESETS = {
  blank: [],

  "breaking-news": [
    {
      id: makeId(), type: "shape", x: 0, y: 1680, w: 1080, h: 160, z: 1,
      rotation: 0, opacity: 1, kind: "rect", fill: "#cc0000", alpha: 1, radius: 0,
    },
    {
      id: makeId(), type: "text", x: 40, y: 1692, w: 1000, h: 136, z: 2,
      rotation: 0, opacity: 1, label: "Breaking News Headline",
      defaultText: "Breaking News Headline", font: "Heebo", size: 72, weight: 700,
      color: "#ffffff", align: "center",
    },
  ],

  "lower-third": [
    {
      id: makeId(), type: "shape", x: 60, y: 1580, w: 12, h: 220, z: 1,
      rotation: 0, opacity: 1, kind: "rect", fill: "#ff5722", alpha: 1, radius: 2,
    },
    {
      id: makeId(), type: "text", x: 90, y: 1590, w: 700, h: 100, z: 2,
      rotation: 0, opacity: 1, label: "Name",
      defaultText: "Name Here", font: "Heebo", size: 80, weight: 700,
      color: "#ffffff", align: "start",
    },
    {
      id: makeId(), type: "text", x: 90, y: 1700, w: 700, h: 80, z: 3,
      rotation: 0, opacity: 1, label: "Title",
      defaultText: "Title / Role", font: "Heebo", size: 52, weight: 400,
      color: "#dddddd", align: "start",
    },
  ],

  watermark: [
    {
      id: makeId(), type: "logo", x: 820, y: 60, w: 200, h: 200, z: 1,
      rotation: 0, opacity: 0.85,
    },
    {
      id: makeId(), type: "text", x: 760, y: 270, w: 280, h: 60, z: 2,
      rotation: 0, opacity: 0.75, label: "Caption",
      defaultText: "channel.name", font: "Heebo", size: 40, weight: 400,
      color: "#ffffff", align: "center",
    },
  ],
};
